import ProductListQuery from 'Query/ProductList.query';
import {
    CartQuery as SourceCartQuery
} from 'SourceQuery/Cart.query';
import { Field } from 'Util/Query';

/** @namespace Bodypwa/Query/Cart/Query */
export class CartQuery extends SourceCartQuery {
    _getCartTotalsFields() {
        return [
            'id',
            'subtotal',
            'subtotal_incl_tax',
            'items_qty',
            'tax_amount',
            'grand_total',
            'discount_amount',
            'quote_currency_code',
            'subtotal_with_discount',
            'coupon_code',
            'shipping_amount',
            'shipping_incl_tax',
            'shipping_tax_amount',
            'is_virtual',
            'applied_rule_ids',
            'shipping_amount',
            'shipping_incl_tax',
            'shipping_tax_amount',
            'shipping_method',
            'is_in_store_pickup_available',
            this._getCartItemsField(),
            this._getAppliedTaxesField()
        ];
    }

    _getCartItemFields() {
        return [
            'qty',
            'sku',
            'price',
            'price_incl_tax',
            'item_id',
            'row_total',
            'row_total_incl_tax',
            'tax_amount',
            'tax_percent',
            'discount_amount',
            'discount_percent',
            this._getCustomizableOptionsFields(),
            this._getDownloadableLinksField(),
            this._getBundleOptionsField(),
            this._getProductField()
        ];
    }

    _getProductField(isVariant = false) {
        if (isVariant) {
            return new Field('product')
                .addFieldList(ProductListQuery._getCartProductInterfaceFields());
        }

        return new Field('product_optimized')
            .setAlias('product')
            .addFieldList(ProductListQuery._getCartProductInterfaceFields());
    }

    _getVariantFields() {
        return [
            this._getProductField(true)
        ];
    }

    getCreateEmptyCartGuestMutation() {
        return new Field('createEmptyCartGuest');
    }
}

export default new CartQuery();
